import FullPageLoader from 'components/common/FullPageLoader';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';

const PdfForm = ({ data, invoiceNumber, loader, type }) => {
    const { checkPermission } = usePermissions();
    const clientData = data?.client || data;
    // const totalBill = clientData?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0).toFixed(2);
    console.log(clientData?.appointments, 'lientData?.appointments,');
    const totalBill = clientData?.appointments?.reduce((sum, item, index) => {
            // Agar custom pricing hai → calcCustomTotal se calculate karo
            const amount = item?.appointment_custom_pricing
                ? parseFloat(calcCustomTotal(item).total)
                : parseFloat(item?.invoice?.total_amount || 0);

            console.log(
                `#${index + 1} =>`,
                'Has custom pricing:', !!item?.appointment_custom_pricing,
                'Amount:', amount
            );

            return sum + amount;
        }, 0)
        .toFixed(2);
    console.log(totalBill, 'totalBilltotalBill')
    return (
        <>
            <div className="page">
                <header>
                    <div className="us">
                        <img src="/main-logo.png" alt="Logo" />
                    </div>

                    <div className='d-flex align-items-center'>
                        <div className="title">
                            <h4>INVOICE # {data?.invoice_number || invoiceNumber || 'N/A'}</h4>
                        </div>
                        <div className="title">
                            <h4>Date: {data?.billing_date
                                ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                : new Date().toLocaleDateString('en-GB')}</h4>
                        </div>
                    </div>
                </header>

                <section>
                    <div className="billed-to">
                        <h1>Bill To</h1>
                        <h2>{clientData?.user?.name}</h2>
                        {clientData?.billing_person && (
                            <h3>{clientData?.billing_person}</h3>
                        )}
                        <h3>{clientData?.billing_email}</h3>
                        <h3>{clientData?.billing_zipcode + " " + clientData?.city?.name}</h3>
                        <h3>{clientData?.state?.name}</h3>
                    </div>

                    <div className="invoice-table-wrapper">
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientData?.appointments.map((val, index) => {
                                    const totalHours = val?.invoice?.total_hours;
                                    const totalMinutes = val?.invoice?.total_hours ? (parseInt(totalHours.split(":")[0]) * 60) + parseInt(totalHours.split(":")[1]) : 0;

                                    const minDuration = val?.invoice?.min_duration;
                                    const minDurUnit = val?.invoice?.duration_unit;
                                    const minDurationHours = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                                    const isValid = totalMinutes >= minDurationHours;
                                    const inc = val?.invoice?.incremental;
                                    const incremental = inc == '30_minute' ? '30 minute' : inc == '1_hour' ? 'hourly' : inc == 'minute' ? 'per minute' : null;
                                    const rushFee = val?.invoice?.rush_fee;
                                    const estMinutes = val.estimated_duration_unit === "hour"
                                        ? val.estimated_duration * 60
                                        : val.estimated_duration;
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {checkPermission('Detail Appointments') ?
                                                    <span>Appointment Number: {val?.appid ? <Link to={`/appointments/view/${val?.id}`}>{val?.appid}</Link> : 'N/A'}</span>
                                                    :
                                                    <span>Appointment Number: {val?.appid || 'N/A'}</span>

                                                }
                                                {type !== 'compressed' &&
                                                    <>
                                                        <br /><span>Language: {val?.language?.name || 'N/A'}</span><br />
                                                        <span>Status: {val?.status || 'N/A'}</span><br />
                                                        <span>Appointment type: {val?.type || 'N/A'}</span><br />
                                                        <span>Appointment date: {moment(val.date).format("DD/MM/YYYY") || 'N/A'}</span><br />
                                                        <span>
                                                            Appointment start: {val?.appointment_assign?.checkin_time
                                                                ? `${moment(val.appointment_assign.checkin_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkin_time, "HH:mm:ss").format("h:mm A")}`
                                                                : 'N/A'}
                                                        </span><br />
                                                        <span>
                                                            Appointment end: {val?.appointment_assign?.checkout_time
                                                                ? `${moment(val.appointment_assign.checkout_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkout_time, "HH:mm:ss").format("h:mm A")}`
                                                                : 'N/A'}
                                                        </span><br />
                                                        <span className='vertical_center'>
                                                            Appointment duration: {val?.invoice?.total_hours
                                                                ? moment.utc(moment.duration(val.invoice.total_hours, "HH:mm").asMilliseconds()).format("HH:mm")
                                                                : 'N/A'}&nbsp;

                                                            {(isValid === false || incremental != null) && (
                                                                <span className="font-bold text-red-600">
                                                                    {`(`}
                                                                    {isValid === false ? `min duration: ${minDuration} ${minDurUnit}` : ""}
                                                                    {isValid === false && incremental != null ? `, ` : ""}
                                                                    {incremental != null ? `Incremental: ${incremental}` : ""}
                                                                    {`)`}
                                                                </span>
                                                            )}
                                                        </span><br />
                                                        <span>Estimated duration: {val?.estimated_duration + ' ' + val?.estimated_duration_unit || 0}</span><br />
                                                        <span>Rate: ${val?.invoice?.rate || 0}{val?.invoice?.rate_unit ? `/${val.invoice.rate_unit}` : ''}</span><br />
                                                        {/* { rushFee > 0 && <><span className='vertical_center'>Rush fee: ${rushFee} <span className="font-bold text-red-600">{`(The appointment is scheduled within 24 hours.)`}</span></span><br /></>} */}
                                                        <span>Rush Fee: ${val?.invoice?.rush_fee || 'N/A'}</span><br />
                                                        <span>Booking Fee: ${val?.invoice?.booking_fee || 'N/A'}</span><br />

                                                        {val?.appointment_custom_pricing && (
                                                            <>
                                                                <span>Mileage (Miles): {val?.appointment_custom_pricing?.mileage || 'N/A'}</span><br />
                                                                <span>Mileage Rate: ${val?.appointment_custom_pricing?.mileage_rate || 'N/A'}</span><br />
                                                                <span>Mileage Total: ${val?.appointment_custom_pricing?.mileage_total || 'N/A'}</span><br />

                                                                <span>Travel (hrs): {val?.appointment_custom_pricing?.travel_hours || 'N/A'}</span><br />
                                                                <span>Travel hourly Rate: ${val?.appointment_custom_pricing?.travel_rate || 'N/A'}</span><br />
                                                                <span>Travel Total: ${val?.appointment_custom_pricing?.travel_total || 'N/A'}</span><br />

                                                                <span>Duration Total: {val?.appointment_custom_pricing?.travel_hours || 'N/A'}</span><br />
                                                                <span>Session Total: ${val?.appointment_custom_pricing?.travel_rate || 'N/A'}</span><br />
                                                                <span>Discount: ${val?.appointment_custom_pricing?.discount || 'N/A'}</span><br />

                                                                {parseFloat(val?.appointment_custom_pricing?.rental_total) > 0 && (
                                                                    <>
                                                                        <span>Rental Rate: ${val?.appointment_custom_pricing?.rental_rate || 'N/A'}</span><br />
                                                                        <span>Rental Quantity: {val?.appointment_custom_pricing?.rental_qty || 'N/A'}</span><br />
                                                                        <span>Rental Total: ${val?.appointment_custom_pricing?.rental_total || 'N/A'}</span><br />
                                                                    </>
                                                                )}

                                                                {parseFloat(val?.appointment_custom_pricing?.addon_rental_total) > 0 && (
                                                                    <>
                                                                        <span>Addon Rental Rate: ${val?.appointment_custom_pricing?.addon_rental_rate || 'N/A'}</span><br />
                                                                        <span>Addon Rental Quantity: {val?.appointment_custom_pricing?.addon_rental_qty || 'N/A'}</span><br />
                                                                        <span>Addon Rental Total: ${val?.appointment_custom_pricing?.addon_rental_total || 'N/A'}</span><br />
                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                        <span>Incremental: 15 minutes</span><br />
                                                        <span> Incremental Amount: ${calcCustomTotal(val).incrementalAmount}</span><br />
                                                        <span>Facility: {val?.appointment_details?.facility?.facility_name || 'N/A'}</span><br />
                                                        <span>Facility Address {val?.appointment_details?.address || 'N/A'}</span><br />
                                                        <span>Department: {val?.appointment_details?.department?.department_name || 'N/A'}</span><br />
                                                        <span>Department text: {val?.appointment_details?.department_text || 'N/A'}</span><br />
                                                        <span>Requestor Name: {val?.appointment_details?.requester_name || 'N/A'}</span><br />
                                                        <span>Requestor Email: {val?.appointment_details?.requester_email || 'N/A'}</span><br />
                                                        <span>Requestor Phone: {val?.appointment_details?.requester_phone || 'N/A'}</span><br />
                                                        <span>Interpreter Name: {val?.interpreter ? `${val.interpreter.first_name} ${val.interpreter.last_name}` : 'N/A'}</span><br />
                                                        {/* <span>Interpreter Gender: {val?.appointment_details?.interpreter_gender || 'N/A'}</span><br /> */}
                                                        <span>comments: {val?.appointment_assign?.comments || 'N/A'}</span><br />
                                                        <span>Notes: {val?.appointment_assign?.notes || 'N/A'}</span>
                                                    </>
                                                }
                                            </td>
                                            <td>
                                                {val?.appointment_custom_pricing
                                                    ? calcCustomTotal(val).total
                                                    : (val?.invoice?.total_amount
                                                        ? val.invoice.total_amount.toFixed(2)
                                                        : 0)}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <table className="info-container last_info">
                        <tr>
                            <th className='text-end last_due'>Total Due</th>
                            <th className='text-end last_due'>
                                ${
                                    totalBill
                                }
                            </th>
                        </tr>
                    </table>

                </section>
            </div>
            {loader &&
                <FullPageLoader />
            }
        </>
    )
}

export default PdfForm


const calcCustomTotal = (val) => {
    // if custom pricing exists
    const baseTotal = parseFloat(val?.appointment_custom_pricing?.appointment_total || 0);

    // Extra duration (actual time - estimated time)
    const extraMinutes = parseInt(val?.invoice?.extra_duration || 0);

    // Incremental duration type
    let incValue = 0;
    if (val?.invoice?.incremental === "15_minute") incValue = 15;
    else if (val?.invoice?.incremental === "30_minute") incValue = 30;
    else if (val?.invoice?.incremental === "1_hour") incValue = 60;

    // Round extra minutes to nearest incremental block
    const roundedExtra =
        incValue > 0 ? Math.ceil(extraMinutes / incValue) * incValue : extraMinutes;

    // Convert rate to per-minute
    const rate = parseFloat(val?.invoice?.rate || 0);
    const rateUnit = val?.invoice?.rate_unit;
    const perMinuteRate = rateUnit === "hour" ? rate / 60 : rate;

    // Calculate incremental total
    const incrementalTotal = roundedExtra * perMinuteRate;

    console.log(roundedExtra , 'roundedExtra');
    console.log(perMinuteRate , 'perMinuteRate');
    // Rush + Booking fee
    // const rushFee = parseFloat(val?.invoice?.rush_fee || 0);
    // const bookingFee = parseFloat(val?.booking_fee || 0);
    // ✅ Final Total (custom total + incremental + rush + booking)
    const grandTotal = baseTotal + incrementalTotal;

    console.log(incrementalTotal , 'incrementalTotal');

    return {
    total: grandTotal.toFixed(2),
    incrementalAmount: incrementalTotal.toFixed(2),
  };
};